import * as Diagram from "../../../../components/diagram";
import { generateSerialArray } from "../../../common";
import moment from "moment";

export const ChronicDiseaseTypeStatistic = {
  label: "個案慢性疾病統計",
  key: "ChronicDiseaseTypeStatistic",
  path: "ElderlyHealth/ChronicDiseaseTypeStatistic",
  api: "TCS_V_HealthVisitElderlyChronicDiseases",
  render: (options) => (
    <Diagram.ElderlyHealth.ChronicDiseaseTypeStatistic {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  filterColumns: [
    {
      key: "noback_year",
      label: "篩檢年份",
      type: "singleDropdown",
      options: generateSerialArray(2023, Number(moment().format("YYYY"))).map(
        (item) => ({ label: item, value: item })
      ),
    },
  ],
  columns: [],
};
